"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenTextInput = void 0;
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const _store_1 = __importDefault(require("@store")); // Component
var CtaForm = function CtaForm(_ref) {
    var title = _ref.title, titleIntro = _ref.titleIntro, subject = _ref.subject;
    var _React$useState = react_1.default.useState(false), processing = _React$useState[0], setProcessing = _React$useState[1];
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }), user = _useGlobal[0];
    var _React$useState2 = react_1.default.useState(user === null || user === void 0 ? void 0 : user.firstName), firstName = _React$useState2[0], setFirstName = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(user === null || user === void 0 ? void 0 : user.lastName), lastName = _React$useState3[0], setLastName = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(user === null || user === void 0 ? void 0 : user.email), email = _React$useState4[0], setEmail = _React$useState4[1];
    var _React$useState5 = react_1.default.useState(user === null || user === void 0 ? void 0 : user.phone), phone = _React$useState5[0], setPhone = _React$useState5[1];
    var _React$useState6 = react_1.default.useState("1"), travelerCount = _React$useState6[0], setTravelerCount = _React$useState6[1];
    var formEnabled = function formEnabled() {
        var pass = true;
        [firstName, lastName, email, phone, travelerCount].map(function (val) {
            if (pass)
                pass = val !== "" && val !== undefined;
        });
        return pass;
    };
    var sendForm = function sendForm(e) {
        var _document;
        e.preventDefault();
        setProcessing(true);
        var form = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById("cta-form");
        setTimeout(function () {
            return form.submit();
        }, 5);
    };
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Background, null, /*#__PURE__*/ react_1.default.createElement(StyledSectionHeader, {
        title: titleIntro + "<br />" + title,
        subhead: "Enter your details below and our travel team will be in touch.",
        lowercase: true,
        invert: true
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, null, /*#__PURE__*/ react_1.default.createElement(Form, {
        id: "cta-form",
        action: "https://info.prior.club/l/652343/2019-01-28/57zq",
        method: "POST",
        onSubmit: function onSubmit(e) {
            return sendForm(e);
        }
    }, /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "firstName",
        value: firstName
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "lastName",
        value: lastName
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "email",
        value: email
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "phone",
        value: phone
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "travelerCount",
        value: travelerCount
    }), /*#__PURE__*/ react_1.default.createElement(exports.HiddenTextInput, {
        type: "text",
        id: "pardot_extra_field",
        name: "pardot_extra_field"
    }), /*#__PURE__*/ react_1.default.createElement(Grid, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: firstName,
        label: "First Name",
        onChange: function onChange(e) {
            return setFirstName(e.target.value);
        },
        className: "span_2",
        required: true,
        noBorder: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: lastName,
        label: "Last Name",
        onChange: function onChange(e) {
            return setLastName(e.target.value);
        },
        className: "span_2",
        required: true,
        noBorder: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "email",
        value: email,
        label: "Email Address",
        onChange: function onChange(e) {
            return setEmail(e.target.value);
        },
        required: true,
        noBorder: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "tel",
        value: phone,
        label: "Phone Number",
        onChange: setPhone,
        required: true,
        noBorder: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        value: travelerCount,
        label: "Number of Travelers",
        onChange: function onChange(e) {
            return setTravelerCount(e.target.value);
        },
        options: ['One', 'Two', 'Three', 'Four or More'],
        required: true,
        noBorder: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "subject",
        value: subject
    }), /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        type: "gold",
        size: "large",
        shadow: true,
        display: "flex",
        disabled: !formEnabled || processing,
        onClick: function onClick() { }
    }, {
        processing: processing
    }), "Submit Reservation")))))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "CtaForm__Wrapper",
    componentId: "sc-1xypees-0"
})(["padding:32px 0px;", "{padding:40px 0px;}", "{padding:48px 0px;}", "{padding:64px 0px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Background = styled_components_1.default.div.withConfig({
    displayName: "CtaForm__Background",
    componentId: "sc-1xypees-1"
})(["background-color:", ";color:", ";padding:64px 0px;", "{padding:80px 0px;}", "{padding:96px 0px;}", "{padding:128px 0px;}"], _theme_1.palette.ink, _theme_1.palette.snow, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledSectionHeader = styled_components_1.default(atoms_1.SectionHeader).withConfig({
    displayName: "CtaForm__StyledSectionHeader",
    componentId: "sc-1xypees-2"
})(["padding-top:0 !important;"]); // Form
var Form = styled_components_1.default.form.withConfig({
    displayName: "CtaForm__Form",
    componentId: "sc-1xypees-3"
})(["display:flex;justify-content:center;width:100%;"]);
var Grid = styled_components_1.default.div.withConfig({
    displayName: "CtaForm__Grid",
    componentId: "sc-1xypees-4"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(20%,1fr) );grid-gap:16px;max-width:380px;& > div{grid-column:span 4;}.span_2{grid-column:span 2;}", "{max-width:480px;}", "{max-width:592px;}", "{max-width:680px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "CtaForm__ButtonWrapper",
    componentId: "sc-1xypees-5"
})(["padding-top:8px;", "{padding-top:16px;}"], _utils_1.mediaQuery('desktop')); // required by Pardot
// https://help.salesforce.com/articleView?id=pardot_forms_add_honeypot.htm&type=5
// note: this is dinging us for accessibility because it doesn't have an associated Label
exports.HiddenTextInput = styled_components_1.default.input.withConfig({
    displayName: "CtaForm__HiddenTextInput",
    componentId: "sc-1xypees-6"
})(["position:absolute;left:-9999px;"]); // Typing
exports.default = CtaForm;
